module.exports = __webpack_public_path__ + "static/media/No_Photo_Empty_State.e6a21239.svg";